module.exports = __webpack_public_path__ + "img/luzhangzi2.58242480.png";